import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Select from "@material-ui/core/Select";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuItem from "@material-ui/core/MenuItem";
import { Button } from "@material-ui/core";
import getDate from 'date-fns/getDate';
import getHours from 'date-fns/getHours';
import getSeconds from 'date-fns/getSeconds';
import getMinutes from 'date-fns/getMinutes';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import api from "../../store/api";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  btnContainer: {
    marginTop: 30,
    marginBottom:30,
    marginLeft:32,
    marginRight:32,
    display: "flex",
    justifyContent: "space-between",
  },
  cancelBtn: {
    backgroundColor: "#ececec",
  },
  applyBtn: {
    backgroundColor: "#0049a3",
    color: "#FFF",
    "&:hover": {
      backgroundColor: "#0049a3AA"
    }
  },
  selectField: {
    width: 90,
    color:"#333333"
  },
  selectYearField: {
    width: 115,
  },
  tableCell: {
    paddingLeft: 0,
    paddingRight:0,
  },
  tableHeader: {
    paddingLeft: 10,
    opacity: 0.5,
    fontWeight: 500,
    fontSize: 15,
    paddingTop:0,
    paddingBottom:0,
    borderBottom:"none"
  },
  subtitle2: {
    fontSize: 15,
    fontWeight: 600,
    color:"#333333",
    paddingBottom:5
  },
  subtitle1: {
    fontSize: 20,
    fontWeight: 700,
    color:"#333333",
    marginTop:15,
    marginBottom:15,
    marginLeft:32
  },
  tableRowHeader: {
    fontSize: 15,
    fontWeight: 600,
    color:"#333333",
    paddingLeft:32,
    paddingRight:0
  },
  closeBtn:{
    padding:0
  },
  popupTitle:{
    marginTop:5
  },
  dialogContent:{
    paddingLeft:0,
    paddingRight:0,
    paddingBottom:0
  },
  gridContainer:{
    paddingLeft:32,
    paddingRight:32
  },
  gridItem:{
    paddingRight:15
  },
  divider:{
    marginTop:20,
  },
  gridMargin:{
    marginTop:10
  },
  menuLabel:{
    color:"#333333",
  },
  dialogTitle:{
    paddingTop:10,
    paddingBottom:10
  }
}));

const dropDownObject = {
  hour: new Array(24).fill(0).map((item, index) => ({ value: index, label: ("0" + index).slice(-2) })),
  month: new Array(12).fill(0).map((item, index) => ({ value: index + 1, label: ("0" + (index + 1)).slice(-2) })),
  minute: new Array(60).fill(0).map((item, index) => ({ value: index, label: ("0" + index).slice(-2) })),
  second: new Array(60).fill(0).map((item, index) => ({ value: index, label: ("0" + index).slice(-2) })),
  day: new Array(31).fill(0).map((item, index) => ({ value: index + 1, label: ("0" + (index + 1)).slice(-2) })),
  year: new Array(10).fill(0).map((item, index) => ({ value: new Date().getFullYear() - index + 1, label: (new Date().getFullYear() - index + 1).toString() })),
};

interface IAppDropdown {
  list: {
    value: number;
    label: string;
  }[];
  className?: string | null;
  defaultValue: any
  onChange: any
}

interface IReasonForDelay{
  name: string,
  reasonForDelayId:string,
}

const AppDropdown = ({ list, className = null, defaultValue=null, onChange }: IAppDropdown) => {
  const classes = useStyles();

  return (
    <Select fullWidth={false} variant="outlined"  IconComponent={KeyboardArrowDownIcon} value={defaultValue ? defaultValue : list[0].value} className={className ?? classes.selectField} onChange={(e) => onChange(e.target.value)}>
      {list.map((item) => {
        return (
          <MenuItem key={item.value} value={item.value} classes={{root:classes.menuLabel}}>
            {item.label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

const isDateValid = (year: number, month: number, day: number) => {
    if (day <= new Date(year, month, 0).getDate())
        return true;
    return false;
}

const EditPopUp = (props: any) => {
  const { tripEventsState } = props;
  const classes = useStyles();
  const closePopup = () => {
    // props.setDistance("0");
    // props.setDiscount("0");
    // props.setReasonForDelayId("");
    // props.setStatus(null);
    props.onClose(false);
  }
  const update =  async () => {
    let updateData = {
      discount:props.discount ? parseFloat(props.discount) : 0,
      distance:props.distance ? parseFloat(props.distance) : 0,
      reasonForDelayId:props.reasonForDelayId,
      status:props.status,
      transferId:props.transferInfo.transferId,
      tripEvents: tripEventsState[0]
    }
    api.updateTransferDetailSMA("",updateData).then( (res) =>{
      props.onClose(false);
      closePopup();
    }).catch((err) => {
      console.log(err);
      closePopup();
    })
    
  }
  
  const StatusRow = ({title, statusInfo, setStatusInfo}: any) => {
    console.log(statusInfo);
    const setStatusInfoHandler = (key: string, value: string) => {
      let [year, month, day, hour, minute, second ] = statusInfo?.createdOn ? format(new Date(statusInfo?.createdOn), 'y-M-d-H-m-s').split("-").map((item) => parseInt(item)) : [2021, 1, 1, 0, 0, 0];
      eval(`${key}=${value}`);
        if (isDateValid(year, month, day)) {
            setStatusInfo((prev: any) => {
              return prev.map((item: any) => {
                return item.status == statusInfo.status ? { ...item, createdOn: format(new Date(year, month - 1, day, hour, minute, second), "y-MM-dd'T'HH:mm:ss") } : item;
              })
            });
        } else {
            alert("Invalid date.");
        }
    }

    return(
    <TableRow key={title}>
      <TableCell component="th" scope="row" className={classes.tableRowHeader}>
        {title}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("hour", e)} list={dropDownObject.hour} defaultValue={getHours(new Date(statusInfo?.createdOn))} />
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("minute", e)} list={dropDownObject.minute} defaultValue={getMinutes(new Date(statusInfo?.createdOn))} />
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("second", e)} list={dropDownObject.second} defaultValue={getSeconds(new Date(statusInfo?.createdOn))} />
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("day", e)} list={dropDownObject.day} defaultValue={getDate(new Date(statusInfo?.createdOn))}/>
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("month", e)} list={dropDownObject.month} defaultValue={getMonth(new Date(statusInfo?.createdOn)) + 1} />
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        <AppDropdown onChange={(e: string) => setStatusInfoHandler("year", e)}
          list={dropDownObject.year}
          className={classes.selectYearField}
          defaultValue={getYear(new Date(statusInfo?.createdOn))}
        />
      </TableCell>
    </TableRow>
  )
};

  
  return (
    <Dialog open={props.popState} fullWidth={false} maxWidth="md">
      <MuiDialogTitle className={classes.dialogTitle}>
        <div className={classes.titleContainer}>
          <Typography variant="subtitle2" classes={{ subtitle2: classes.subtitle2, root:classes.popupTitle }}>
            Edit Transfer
          </Typography>
          {
            <IconButton aria-label="close" className={classes.closeBtn} onClick={() => closePopup()}>
              <CloseIcon />
            </IconButton>
          }
        </div>
      </MuiDialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <Grid container  className={classes.gridContainer}>
          <Grid item md={3} className={classes.gridItem}>
            <Typography variant="subtitle2" classes={{ subtitle2: classes.subtitle2 }}>
              Distance(km)
            </Typography>
            <TextField variant="outlined" value={props.distance} onChange={(e) => props.setDistance(e.target.value)} />
          </Grid>
          <Grid item md={7} className={classes.gridItem}>
            <Typography variant="subtitle2" classes={{ subtitle2: classes.subtitle2 }}>
              Status
            </Typography>
            <Select key="Status" fullWidth={true} variant="outlined" IconComponent={KeyboardArrowDownIcon}  value={props.status} onChange={(e: any) => props.setStatus(e.target.value)}>
              <MenuItem key={4} value={4}>
                Complete 
              </MenuItem>
              <MenuItem key={6} value={6}>
                Aborted 
              </MenuItem>
              <MenuItem key={10} value={10}>
                Ended
              </MenuItem>
              <MenuItem key={11} value={11}>
                Cancelled 
              </MenuItem>
            </Select>
          </Grid>
          <Grid item md={2} >
            <Typography variant="subtitle2" classes={{ subtitle2: classes.subtitle2 }}>
              Discount(%)
            </Typography>
            <TextField variant="outlined" defaultValue={0} value={props.discount} onChange={(e) => props.setDiscount(e.target.value)}/>
          </Grid>
          <Grid item md={12} classes={{root:classes.gridMargin}}>
            <Typography variant="subtitle2" classes={{ subtitle2: classes.subtitle2 }}>
              Reason for delay
            </Typography>
            <Select key="ReasonForDelay" fullWidth={true} variant="outlined" displayEmpty IconComponent={KeyboardArrowDownIcon} value={props.reasonForDelayId} onChange={(e: any) => props.setReasonForDelayId(e.target.value)}>
              <MenuItem key="null" value="null">Select</MenuItem>
              {props.reasonForDelay.map( (delay:IReasonForDelay) =>(
                <MenuItem key={delay.name} value={delay.reasonForDelayId}>
                {delay.name}
                </MenuItem>
              ))}
              
            </Select>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container >
          <Grid item md={12}>
            <Typography variant="subtitle1" classes={{ subtitle1: classes.subtitle1 }}>
              Key Timestamps
            </Typography>
          </Grid>
          <Grid item md={12}>
            <TableContainer>
              <Table>
                <TableHead >
                  <TableRow >
                    <TableCell className={classes.tableHeader}></TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      HOUR
                    </TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      MIN
                    </TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      SEC
                    </TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      DAY
                    </TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      MONTH
                    </TableCell>
                    <TableCell align="center" className={classes.tableHeader}>
                      YEAR
                    </TableCell>
                  </TableRow>
                </TableHead>
                {tripEventsState[0].length > 0 && <TableBody>
                  <StatusRow title="Picking up" setStatusInfo={tripEventsState[1]} statusInfo={tripEventsState[0]?.find(({status}:any) => status === 7)} />
                  <StatusRow title="En route to dropoff" setStatusInfo={tripEventsState[1]} statusInfo={tripEventsState[0]?.find(({status}:any) => status === 8)}/>
                  <StatusRow title="Dropoff" setStatusInfo={tripEventsState[1]} statusInfo={tripEventsState[0]?.find(({status}:any) => status === 9)}/>
                  <StatusRow title="Complete" setStatusInfo={tripEventsState[1]} statusInfo={tripEventsState[0]?.find(({status}:any) => status === 4)} />
                </TableBody>}
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Divider />
        <div className={classes.btnContainer}>
          <span>
            <Button className={classes.cancelBtn} onClick={() => closePopup()}>
              Cancel
            </Button>
          </span>
          <span>
            <Button className={classes.applyBtn} onClick={() => update()}>
              Apply
            </Button>
          </span>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditPopUp;
